<template>
  <div>
    <!-- Image -->
    <div v-if="type === 'image'" class="marginBottom">
      <upload-files-v-2 type="image" :multiple="false" allowedImageTypes='image/png, image/jpeg, image/jpg' id="'headerImage'" ref="headerImage" :maxFileSizeAllowed="5" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}">
        <div class="flexContainer">
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
            <p class="sub-title">Max file size 5MB (.jpeg, .jpg, .png only)</p>  
          </div>
          <button class="uploadbttn width100P" :disabled="filesUploading || isViewOnlyMode">
            <VIcon v-if="!filesUploading" name="image-line" class="paddingRight"></VIcon>
            <VProgressRing v-if="filesUploading" class="vvd-spinner-sm" connotation="cta" indeterminate />
            <span v-else>Upload Image</span>
          </button>
          <div v-if="uploadedFileName !== ''" class="uploadedFileContainer width100P">
            <p class="title">{{ uploadedFileName }}</p>
          </div>
        </div>
      </upload-files-v-2>  
    </div>
    <!-- Video -->
    <div v-else-if="type === 'video'" class="marginBottom">
      <upload-files-v-2 type="video" :multiple="false" id="headerVideo" ref="headerVideo" allowedVideoTypes='video/mp4' :maxFileSizeAllowed="16" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}">
        <div class="flexContainer">
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
            <p class="sub-title">Max file size 16MB (.mp4 only)</p>  
          </div>
          <button class="uploadbttn width100P" :disabled="filesUploading || isViewOnlyMode">
            <VIcon v-if="!filesUploading" name="video-line" class="paddingRight"></VIcon>
            <VProgressRing v-if="filesUploading" class="vvd-spinner-sm" connotation="cta" indeterminate />
            <span v-else>Upload Video</span>
          </button>
          <div v-if="uploadedFileName !== ''" class="uploadedFileContainer width100P">
            <p class="title">{{ uploadedFileName }}</p>
          </div>
        </div>
      </upload-files-v-2>  
    </div>
    <!-- Document -->
    <div v-else-if="type === 'document'" class="marginBottom">
      <div class="flex-between">
        <upload-files-v-2 type="document" allowedDocumentTypes='application/pdf' :multiple="false" id="headerDocument" ref="headerDocument" :maxFileSizeAllowed="100" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}">
          <div class="flexContainer">
            <div class="info-box">
              <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
              <p class="sub-title">Max file size 100MB (.pdf only)</p>
            </div>
            <button class="uploadbttn width100P" :disabled="filesUploading || isViewOnlyMode">
              <VIcon v-if="!filesUploading" name="clear-file-line" class="paddingRight"></VIcon>
              <VProgressRing v-if="filesUploading" class="vvd-spinner-sm" connotation="cta" indeterminate />
              <span v-else>Upload Document</span>
            </button>
            <div v-if="uploadedFileName !== ''" class="uploadedFileContainer width100P">
              <p class="title">{{ uploadedFileName }}</p>
            </div>
          </div>
        </upload-files-v-2> 
        <!-- Show Document file -->
        <span v-if="uploadedFileName !== ''" class="tooltip_container info-field"> 
          <VIcon name="info-line" :size="-5" connotation="cta" class="cursorPointer" @click="openLink(uploadedFiles[0])"></VIcon>
          <span class="tooltip_text left" style="width: 100px">View Uploaded Document</span>
        </span>
      </div>
    </div>
  </div>  
</template>

<script>
import uploadFilesV2 from '@/components/uploadFilesV2.vue';
import { useUIStore } from '@/stores/ui';

export default {
  emits: ["uploadedFileData"],
  components: {
    uploadFilesV2
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filesUploading: false,
      uploadedFiles: [],
      uploadedFileName: '',
    };
  },
  methods:{
    async handleFilesUpload (urlData) {
      try {
        this.filesUploading = true;
        this.uploadedFiles = [urlData[0].url];
        this.uploadedFileName = urlData[0]?.filename;
        this.$emit('uploadedFileData', this.uploadedFiles); 
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
      }
    },
    openLink(payload) {
      if (payload) {
        window.open(payload, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.info-box {
  display: flex;
  align-items: center;
  flex-direction: row;
  background: var(--purple-opac);
  padding: 5px 10px;
  border-radius: 5px;
}
.infoIcon {
  padding-right: 10px;
}
.marginBottom {
	margin-bottom: 20px;
}
.sub-title {
  font-size: 14px;
  color: var(--gray-04);
  font-weight: 400;
  line-height: 16px;
  margin: 0;
}
.flexContainer {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
}
.paddingRight {
	padding-right: 10px;
}
.title {
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  line-height: 16px;
  margin: 0;
}
.uploadedFileContainer {
  background: var(--background-primary);
  padding: 10px;
  border-radius: 5px;
}
.uploadbttn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border: 1px solid var(--purple);
  border-radius: 5px;
  background: var(--white);
  color: var(--purple);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.uploadbttn:hover {
  background: var(--purple-opac);
}
.uploadbttn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
